<template>
  <div class="full-width text-end">
    <v-menu open-on-hover bottom offset-y>
      <template v-slot:activator="{ on, attrs }">
        <v-btn color="green" dark v-bind="attrs" v-on="on" outlined>
          Xuất Excel điểm tất cả môn học
        </v-btn>
      </template>
      <v-list>
        <v-list-item class="cursor-pointer" @click="() => $refs['export-dialog'].openPopup('student')">
          <v-list-item-title>Theo học sinh</v-list-item-title>
        </v-list-item>
        <v-list-item class="cursor-pointer" @click="() => $refs['export-dialog'].openPopup('class')">
          <v-list-item-title>Theo lớp</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
    <ExcelExportDialog ref="export-dialog" />
  </div>
</template>
<script>
import ExcelExportDialog from './export/index.vue'
export default {
  components: { ExcelExportDialog }
}
</script>
